<template>
  <header class="c-pageheader">
    <div class="l-wrapper">
      <PartsdataLogo />
      <nav class="c-nav--options">
        <LanguagePicker />
        <div class="shopping-functions">
          <div class="c-nav--options__buttonrow">
            <Button>Warenkorb</Button>
            <Button>Anmelden</Button>
          </div>
        <Search />
        </div>
      </nav>
      <nav class="c-nav--search"></nav>
      <MainNavigation />
    </div>
  </header>
</template>

<script>
import PartsdataLogo from '@/components/atoms/PartsdataLogo'
import LanguagePicker from '@/components/organisms/LanguagePicker'
import MainNavigation from '@/components/molecules/MainNavigation'
import Search from '@/components/molecules/Search'
import Button from '@/components/atoms/Button'
export default {
  name: 'PageHeader',
  components: { Button, Search, MainNavigation, LanguagePicker, PartsdataLogo }
}
</script>

<style scoped lang="sass">
  .c-pageheader
    padding-bottom: 2.3em
    background-color: $dark-blue
    .c-wrapper
      padding: 0em 0.7em 0em 0em
  .l-wrapper
    //@include outer-container
    max-width: 1000px
    padding: 0 0.7em
    position: relative
    margin: auto
</style>
